import React from 'react';
import { Paragraph } from 'components/core/Typography';

import './InactiveFacilityBanner.scss';

function InactiveFacilityBanner() {
	return (
		<div className="inactive-facility-banner">
			<Paragraph
				weight="ultraBold"
				size="small"
				last
				className="main-message"
			>
				Online reservations aren’t available through SpareFoot. Please
				contact the facility directly to book.
			</Paragraph>
		</div>
	);
}

export default InactiveFacilityBanner;
